import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(40, 44, 52);
  background: linear-gradient(
    90deg,
    rgba(80, 6, 9, 1) 15%,
    rgba(21, 0, 0, 1) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;


  @media (max-width: 550px) {
        /* Phones */
        overflow-y: scroll;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        overflow-y: scroll;
      }
     
`;

export const FormContainer = styled.div`
  width: 80%;
  padding: 4em 0em 4em 4em;
  color: white;
  border-radius: 25px;
  margin-bottom: 2em;
  background: linear-gradient(180deg, rgba(119, 124, 134, 0.3) 0%, rgba(118, 130, 154, 0.05) 100%);
`;

export const Title = styled.h2`
  font-size: 2.5em;
`;

export const Form = styled.form`
  margin-top: 2em;
  display: flex;
  flex-direction: column;
`;

export const InputGroup = styled.div`
width: 80%;
display: flex;
  margin-bottom: 30px;

  @media (max-width: 550px) {
        /* Phones */
        flex-direction: column;
        width: 100%;
        margin-bottom: 0px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
        width: 100%;
        margin-bottom: 0px;
      }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  width:45%;
  padding: 15px 0 20px 20px;
  border: none;
  border-radius: 50px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  margin-right: 20px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  @media (max-width: 550px) {
        /* Phones */
        flex-direction: column;
        width: 85%;
        margin-bottom: 20px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
        width: 85%;
        margin-bottom: 20px;
      }
`;
export const InputEmail = styled.input`
  width:93%;
  padding: 15px 0 20px 20px;
  border: none;
  border-radius: 50px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  margin-right: 20px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  @media (max-width: 550px) {
        /* Phones */
        flex-direction: column;
        width: 85%;
        margin-bottom: 0px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
        width: 85%;
        margin-bottom: 0px;
      }
`;

export const SubmitButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-top: 10px;

  button {
    width: 40%;
    background: rgba(234, 11, 42, 1);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 1rem;
    margin-bottom: 1em;

    padding: 8px 40px;
    border-radius: 30px;
    text-align: center;

    @media (max-width: 550px) {
        /* Phones */
        flex-direction: column;
        width: 85%;
        margin-bottom: 0px;
      }

      @media (max-width: 1100px) {
        /* Tablets */
        flex-direction: column;
        width: 85%;
        margin-bottom: 0px;
      }

    &:hover {
      background: rgb(210, 11, 37);
    }
  }
`;

export const LoginLink = styled.p`
  a {
    color: #e74c3c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
